var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFondoLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 832,
    viewBox: "0 0 1280 832",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_114_2)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 832,
    fill: "#0E1426"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M170.838 766.347C493.208 766.347 754.541 685.483 754.541 585.732C754.541 485.981 493.208 405.117 170.838 405.117C-151.533 405.117 -412.865 485.981 -412.865 585.732C-412.865 685.483 -151.533 766.347 170.838 766.347Z",
    fill: "url(#paint0_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M303.017 733.322C759.213 733.322 1129.03 705.71 1129.03 671.649C1129.03 637.588 759.213 609.977 303.017 609.977C-153.18 609.977 -523 637.588 -523 671.649C-523 705.71 -153.18 733.322 303.017 733.322Z",
    fill: "url(#paint1_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M479.229 572.522H405.59L362.178 538.046H298.744L262.921 566.487H75.183L53.1922 549.003H-5.00977V547.19H54.1247L76.1414 564.673H261.989L297.811 536.233H363.136L406.522 570.709H478.297L542.715 519.552H708.618L755.345 482.434H774.15L806.424 456.791H864.808L937.437 399.107L939.043 400.377L865.74 458.604H807.357L775.109 484.222H756.278L709.551 521.339H543.648L479.229 572.522Z",
    fill: "url(#paint2_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M941.114 402.268C942.772 400.947 942.772 398.797 941.114 397.476C939.457 396.155 936.737 396.155 935.079 397.476C933.422 398.797 933.422 400.947 935.079 402.268C936.763 403.589 939.457 403.589 941.114 402.268Z",
    fill: "url(#paint3_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M961.914 810.873L912.648 771.735H877.862L817.225 723.557H787.93L747.004 756.09H695.122L644.018 715.476H564.291L525.101 746.61H437.371L392.146 710.684H307.291L297.578 718.403H242.562L218.913 699.624H96.7329L78.472 714.103H-12.4961V712.316H77.5395L95.8004 697.811H219.871L243.494 716.59H296.619L306.358 708.871H393.079L438.303 744.797H524.169L563.333 713.689H644.95L696.055 754.277H746.072L786.997 721.77H818.157L878.794 769.922H913.58L963.52 809.604L961.914 810.873Z",
    fill: "url(#paint4_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M959.556 812.531C961.213 813.852 963.933 813.852 965.591 812.531C967.249 811.21 967.249 809.06 965.591 807.739C963.933 806.418 961.213 806.418 959.556 807.739C957.872 809.06 957.872 811.21 959.556 812.531Z",
    fill: "url(#paint5_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1131.99 743.631L1091.89 711.771H925.055L877.162 673.721H810.024L773.217 644.478H720.196L692.688 666.339H642.36L616.873 646.058H554.604L538.208 659.086H467.055L423.98 624.87H326.588L287.735 655.719H220.804L170.917 616.115H-0.347656V614.328H171.875L221.737 653.932H286.803L325.656 623.057H424.912L467.988 657.273H537.276L553.646 644.27H617.805L643.319 664.526H691.756L719.264 642.665H774.15L810.983 671.908H878.095L925.988 709.958H1092.82L1133.59 742.336L1131.99 743.631Z",
    fill: "url(#paint6_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M-0.114847 618.628C-2.47193 618.628 -4.38867 617.1 -4.38867 615.235C-4.38867 613.37 -2.47193 611.842 -0.114847 611.842C2.24224 611.842 4.15902 613.37 4.15902 615.235C4.15902 617.1 2.24224 618.628 -0.114847 618.628Z",
    fill: "url(#paint7_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1129.6 745.263C1131.26 746.584 1133.98 746.584 1135.66 745.263C1137.32 743.942 1137.32 741.792 1135.66 740.471C1134.01 739.15 1131.29 739.15 1129.6 740.471C1127.94 741.792 1127.94 743.942 1129.6 745.263Z",
    fill: "url(#paint8_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M529.791 632.77H473.946L436.155 602.75H309.986L276.054 629.714H233.445L179.595 586.923H75.6755L50.3951 566.849H0.611328V565.062H51.3276L76.608 585.136H180.527L234.377 627.901H275.096L309.053 600.937H437.087L474.904 630.957H528.832L559.112 606.92H655.26L683.208 629.118H796.634L863.668 575.889H997.012L1025.3 553.432L1026.88 554.701L997.944 577.702H864.601L797.566 630.931H682.25L654.302 608.733H560.044L529.791 632.77Z",
    fill: "url(#paint9_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M0.816794 569.336C-1.54029 569.336 -3.45703 567.808 -3.45703 565.943C-3.45703 564.078 -1.54029 562.55 0.816794 562.55C3.17388 562.55 5.09066 564.052 5.09066 565.943C5.09066 567.834 3.17388 569.336 0.816794 569.336Z",
    fill: "url(#paint10_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1028.95 556.593C1030.63 555.272 1030.63 553.122 1028.95 551.801C1027.26 550.48 1024.57 550.48 1022.91 551.801C1021.26 553.122 1021.26 555.272 1022.91 556.593C1024.6 557.914 1027.29 557.914 1028.95 556.593Z",
    fill: "url(#paint11_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M226.192 641.318L181.226 605.625H72.3333L42.7531 582.132H3.22656V580.319H43.7115L73.2917 603.812H182.158L227.797 640.049L226.192 641.318Z",
    fill: "url(#paint12_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M3.43402 584.618C1.07693 584.618 -0.839844 583.09 -0.839844 581.225C-0.839844 579.36 1.07693 577.832 3.43402 577.832C5.79111 577.832 7.68196 579.36 7.68196 581.225C7.68196 583.09 5.76521 584.618 3.43402 584.618Z",
    fill: "url(#paint13_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M223.808 642.975C225.465 644.296 228.185 644.296 229.869 642.975C231.527 641.654 231.527 639.505 229.869 638.184C228.185 636.863 225.491 636.863 223.808 638.184C222.15 639.505 222.15 641.654 223.808 642.975Z",
    fill: "url(#paint14_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M520.802 615.494H470.293L431.725 584.878H306.488L272.815 611.608H244.815L212.723 586.147L214.329 584.852L245.748 609.821H271.883L305.556 583.064H432.709L471.251 613.707H519.869L557.246 584.023H663.574V585.81H558.179L520.802 615.494Z",
    fill: "url(#paint15_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M210.65 588.012C208.992 586.691 208.992 584.541 210.65 583.22C212.333 581.899 215.027 581.899 216.685 583.22C218.343 584.541 218.343 586.691 216.685 588.012C215.027 589.333 212.307 589.333 210.65 588.012Z",
    fill: "url(#paint16_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M663.366 588.296C665.723 588.296 667.64 586.767 667.64 584.902C667.64 583.037 665.723 581.509 663.366 581.509C661.009 581.509 659.092 583.037 659.092 584.902C659.092 586.767 661.009 588.296 663.366 588.296Z",
    fill: "url(#paint17_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M280.378 583.116H249.943V581.329H279.42L302.084 563.327H366.477V565.114H303.017L280.378 583.116Z",
    fill: "url(#paint18_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M250.178 585.602C247.821 585.602 245.93 584.074 245.93 582.209C245.93 580.344 247.821 578.815 250.178 578.815C252.535 578.815 254.451 580.344 254.451 582.209C254.451 584.074 252.535 585.602 250.178 585.602Z",
    fill: "url(#paint19_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M366.269 567.601C368.627 567.601 370.543 566.098 370.543 564.208C370.543 562.317 368.652 560.814 366.269 560.814C363.886 560.814 362.021 562.343 362.021 564.208C362.021 566.073 363.912 567.601 366.269 567.601Z",
    fill: "url(#paint20_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M493.786 593.581L492.18 592.311L553.852 543.331H746.46L800.596 500.333H910.135L954.195 465.314H1010.84L1052.36 432.314H1129.37V434.128H1053.32L1011.78 467.127H955.127L911.068 502.121H801.528L747.419 545.118H554.811L493.786 593.581Z",
    fill: "url(#paint21_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M496.17 595.212C494.486 596.533 491.792 596.533 490.108 595.212C488.425 593.891 488.425 591.741 490.108 590.42C491.766 589.099 494.486 589.099 496.17 590.42C497.827 591.741 497.827 593.891 496.17 595.212Z",
    fill: "url(#paint22_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1129.14 436.613C1131.49 436.613 1133.41 435.085 1133.41 433.22C1133.41 431.355 1131.49 429.827 1129.14 429.827C1126.78 429.827 1124.86 431.355 1124.86 433.22C1124.86 435.085 1126.78 436.613 1129.14 436.613Z",
    fill: "url(#paint23_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M518.963 599.589L517.383 598.294L572.114 554.83H678.183L709.965 580.059H771.638L818.702 542.708H941.788V544.495H819.634L772.596 581.872H709.006L677.224 556.617H573.072L518.963 599.589Z",
    fill: "url(#paint24_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M521.345 601.221C519.662 602.542 516.968 602.542 515.284 601.221C513.627 599.9 513.627 597.75 515.284 596.429C516.968 595.108 519.662 595.108 521.345 596.429C523.003 597.75 523.003 599.9 521.345 601.221Z",
    fill: "url(#paint25_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M941.58 546.983C943.937 546.983 945.854 545.455 945.854 543.59C945.854 541.725 943.937 540.197 941.58 540.197C939.223 540.197 937.307 541.725 937.307 543.59C937.307 545.455 939.223 546.983 941.58 546.983Z",
    fill: "url(#paint26_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M756.225 565.114H719.521V563.326H755.266L804.377 524.318H949.143L985.018 495.825H1036.02L1064.59 473.109L1066.19 474.379L1036.95 497.639H985.95L950.076 526.131H805.309L756.225 565.114Z",
    fill: "url(#paint27_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M719.728 567.601C717.371 567.601 715.48 566.098 715.48 564.208C715.48 562.317 717.371 560.814 719.728 560.814C722.085 560.814 724.002 562.343 724.002 564.208C724.002 566.073 722.111 567.601 719.728 567.601Z",
    fill: "url(#paint28_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1068.27 476.271C1069.95 474.95 1069.95 472.801 1068.27 471.48C1066.61 470.159 1063.89 470.159 1062.23 471.48C1060.57 472.801 1060.57 474.95 1062.23 476.271C1063.92 477.592 1066.61 477.592 1068.27 476.271Z",
    fill: "url(#paint29_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M792.1 615.623H699.267L674.09 595.626H603.066V593.813H675.022L700.199 613.81H791.141L851.571 565.813H958.78V567.626H852.529L792.1 615.623Z",
    fill: "url(#paint30_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M603.299 598.113C600.916 598.113 599.025 596.585 599.025 594.72C599.025 592.855 600.942 591.327 603.299 591.327C605.656 591.327 607.547 592.855 607.547 594.72C607.547 596.585 605.63 598.113 603.299 598.113Z",
    fill: "url(#paint31_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M958.573 570.114C960.956 570.114 962.846 568.585 962.846 566.72C962.846 564.855 960.956 563.327 958.573 563.327C956.19 563.327 954.299 564.855 954.299 566.72C954.299 568.585 956.215 570.114 958.573 570.114Z",
    fill: "url(#paint32_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M781.402 600.108H706.183L673.443 574.128H583.562V572.315H674.401L707.115 598.321H780.47L835.227 554.831H969.296L1021.85 513.077H1067.67V514.89H1022.78L970.229 556.619H836.159L781.402 600.108Z",
    fill: "url(#paint33_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M583.769 576.615C581.412 576.615 579.521 575.087 579.521 573.222C579.521 571.357 581.438 569.829 583.769 569.829C586.101 569.829 588.043 571.357 588.043 573.222C588.043 575.087 586.152 576.615 583.769 576.615Z",
    fill: "url(#paint34_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1067.47 517.377C1069.82 517.377 1071.74 515.848 1071.74 513.983C1071.74 512.119 1069.82 510.59 1067.47 510.59C1065.11 510.59 1063.19 512.093 1063.19 513.983C1063.19 515.874 1065.11 517.377 1067.47 517.377Z",
    fill: "url(#paint35_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M736.073 533.125H558.385V531.311H735.141L803.729 476.814H874.882L920.496 440.577H993.203L1041.15 402.5L1042.75 403.77L994.161 442.39H921.454L875.815 478.627H804.688L736.073 533.125Z",
    fill: "url(#paint36_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M558.592 535.612C556.235 535.612 554.344 534.083 554.344 532.218C554.344 530.353 556.261 528.825 558.592 528.825C560.923 528.825 562.866 530.353 562.866 532.218C562.866 534.083 560.949 535.612 558.592 535.612Z",
    fill: "url(#paint37_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1044.83 405.661C1046.48 404.34 1046.48 402.19 1044.83 400.869C1043.17 399.548 1040.45 399.548 1038.79 400.869C1037.13 402.19 1037.13 404.34 1038.79 405.661C1040.45 406.982 1043.17 406.982 1044.83 405.661Z",
    fill: "url(#paint38_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M67.6192 697.111H-5.58008V695.323H66.6867L93.1068 674.317H211.635V676.13H94.0652L67.6192 697.111Z",
    fill: "url(#paint39_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M211.428 678.616C213.785 678.616 215.701 677.088 215.701 675.223C215.701 673.358 213.785 671.83 211.428 671.83C209.071 671.83 207.18 673.358 207.18 675.223C207.18 677.088 209.096 678.616 211.428 678.616Z",
    fill: "url(#paint40_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1087.8 736.094H872.369L832.065 704.079H786.4L754.955 729.048H708.772L665.878 694.987H560.949L513.263 732.882H440.866L402.791 702.628H253.62L234.09 687.113H134.16V685.326H235.049L254.553 700.815H403.749L441.825 731.069H512.304L559.99 693.2H666.836L709.704 727.261H754.022L785.442 702.292H832.998L873.301 734.306H1087.8V736.094Z",
    fill: "url(#paint41_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M134.368 689.599C132.01 689.599 130.094 688.071 130.094 686.206C130.094 684.341 132.01 682.813 134.368 682.813C136.725 682.813 138.616 684.341 138.616 686.206C138.616 688.071 136.699 689.599 134.368 689.599Z",
    fill: "url(#paint42_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1087.59 738.607C1089.95 738.607 1091.86 737.079 1091.86 735.214C1091.86 733.349 1089.95 731.821 1087.59 731.821C1085.23 731.821 1083.32 733.323 1083.32 735.214C1083.32 737.105 1085.23 738.607 1087.59 738.607Z",
    fill: "url(#paint43_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1081.5 726.173H918.864L866.05 684.211H796.71L774.149 666.313H731.281L712.165 681.492H632.698L611.769 664.862H592.239L574.936 678.616H466.381L422.943 644.115H347.076L315.605 669.11H241.162V667.323H314.672L346.143 642.328H423.875L467.313 676.829H574.004L591.306 663.075H612.701L633.63 679.678H711.207L730.323 664.5H775.107L797.642 682.398H867.008L919.796 724.359H1081.5V726.173Z",
    fill: "url(#paint44_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M241.37 671.597C239.012 671.597 237.096 670.069 237.096 668.204C237.096 666.339 239.012 664.811 241.37 664.811C243.727 664.811 245.643 666.339 245.643 668.204C245.643 670.069 243.727 671.597 241.37 671.597Z",
    fill: "url(#paint45_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1081.3 728.659C1083.65 728.659 1085.57 727.131 1085.57 725.266C1085.57 723.401 1083.68 721.873 1081.3 721.873C1078.91 721.873 1077.05 723.401 1077.05 725.266C1077.05 727.131 1078.94 728.659 1081.3 728.659Z",
    fill: "url(#paint46_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M197.803 665.122H89.325L66.6866 647.12H3.22656V645.307H67.6191L90.2834 663.309H197.803V665.122Z",
    fill: "url(#paint47_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M3.43402 649.607C1.07693 649.607 -0.839844 648.079 -0.839844 646.214C-0.839844 644.349 1.07693 642.821 3.43402 642.821C5.79111 642.821 7.68196 644.349 7.68196 646.214C7.68196 648.079 5.76521 649.607 3.43402 649.607Z",
    fill: "url(#paint48_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M197.569 667.609C199.926 667.609 201.817 666.081 201.817 664.216C201.817 662.351 199.9 660.823 197.569 660.823C195.238 660.823 193.295 662.351 193.295 664.216C193.295 666.081 195.212 667.609 197.569 667.609Z",
    fill: "url(#paint49_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M182.676 645.618H103.804L80.518 627.124H-6.84961V625.311H81.4764L104.762 643.805H182.676V645.618Z",
    fill: "url(#paint50_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M182.469 648.104C184.826 648.104 186.717 646.575 186.717 644.711C186.717 642.846 184.826 641.317 182.469 641.317C180.112 641.317 178.195 642.846 178.195 644.711C178.195 646.575 180.086 648.104 182.469 648.104Z",
    fill: "url(#paint51_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M517.538 704.882H477.389L424.186 662.61H359.043L337.026 680.12H254.994V678.307H336.068L358.11 660.823H425.145L478.322 703.069H517.538V704.882Z",
    fill: "url(#paint52_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M255.201 682.606C252.844 682.606 250.953 681.077 250.953 679.212C250.953 677.348 252.87 675.819 255.201 675.819C257.532 675.819 259.475 677.348 259.475 679.212C259.475 681.077 257.584 682.606 255.201 682.606Z",
    fill: "url(#paint53_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M517.33 707.368C519.687 707.368 521.604 705.84 521.604 703.975C521.604 702.11 519.687 700.582 517.33 700.582C514.973 700.582 513.082 702.11 513.082 703.975C513.082 705.84 514.973 707.368 517.33 707.368Z",
    fill: "url(#paint54_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M455.605 710.088L411.598 675.12H369.74L348.345 692.112H268.852V690.324H347.413L368.782 673.307H412.556L457.211 708.792L455.605 710.088Z",
    fill: "url(#paint55_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M269.059 694.599C266.702 694.599 264.785 693.071 264.785 691.206C264.785 689.341 266.702 687.812 269.059 687.812C271.416 687.812 273.333 689.341 273.333 691.206C273.333 693.071 271.416 694.599 269.059 694.599Z",
    fill: "url(#paint56_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M453.249 711.72C454.933 713.041 457.627 713.041 459.31 711.72C460.994 710.399 460.994 708.249 459.31 706.928C457.653 705.607 454.933 705.607 453.249 706.928C451.591 708.249 451.591 710.399 453.249 711.72Z",
    fill: "url(#paint57_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M807.252 646.576L805.646 645.307L860.403 601.818H1008.3L1053.27 566.125L1054.88 567.394L1009.26 603.631H861.336L807.252 646.576Z",
    fill: "url(#paint58_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M809.634 648.208C807.977 649.529 805.257 649.529 803.573 648.208C801.916 646.887 801.916 644.738 803.573 643.417C805.257 642.096 807.951 642.096 809.634 643.417C811.292 644.738 811.292 646.887 809.634 648.208Z",
    fill: "url(#paint59_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1056.95 569.284C1058.61 567.963 1058.61 565.813 1056.95 564.492C1055.29 563.171 1052.57 563.171 1050.91 564.492C1049.26 565.813 1049.26 567.963 1050.91 569.284C1052.57 570.605 1055.29 570.605 1056.95 569.284Z",
    fill: "url(#paint60_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1169.08 722.313L1126.65 688.615H1081.97L1061.17 672.115H1015.53L991.623 691.127H930.261L888.714 658.128H821.498V656.315H889.646L931.219 689.314H990.69L1014.6 670.302H1062.13L1082.9 686.828H1127.61L1170.68 721.044L1169.08 722.313Z",
    fill: "url(#paint61_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M821.706 660.614C819.348 660.614 817.432 659.086 817.432 657.221C817.432 655.356 819.348 653.828 821.706 653.828C824.063 653.828 825.979 655.356 825.979 657.221C825.979 659.086 824.063 660.614 821.706 660.614Z",
    fill: "url(#paint62_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1166.7 723.972C1168.38 725.293 1171.07 725.293 1172.76 723.972C1174.42 722.651 1174.42 720.501 1172.76 719.18C1171.07 717.859 1168.38 717.859 1166.7 719.18C1165.04 720.501 1165.04 722.651 1166.7 723.972Z",
    fill: "url(#paint63_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M992.893 647.871H955.749L925.237 623.627H870.143L845.018 643.571L843.412 642.302L869.21 621.813H926.169L956.708 646.058H991.934L1020.76 623.186H1062.44L1086.22 604.304L1087.85 605.573L1063.37 624.999H1021.67L992.893 647.871Z",
    fill: "url(#paint64_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M847.4 645.229C845.717 646.55 843.023 646.55 841.339 645.229C839.681 643.908 839.681 641.759 841.339 640.438C842.997 639.117 845.717 639.117 847.4 640.438C849.058 641.759 849.058 643.908 847.4 645.229Z",
    fill: "url(#paint65_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1089.9 607.464C1091.55 606.143 1091.55 603.993 1089.9 602.672C1088.24 601.351 1085.52 601.351 1083.86 602.672C1082.18 603.993 1082.18 606.143 1083.86 607.464C1085.54 608.785 1088.24 608.785 1089.9 607.464Z",
    fill: "url(#paint66_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1045.76 614.121H978.854V612.308H1044.83L1094.48 572.859L1096.09 574.129L1045.76 614.121Z",
    fill: "url(#paint67_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M979.061 616.609C976.704 616.609 974.787 615.08 974.787 613.215C974.787 611.35 976.704 609.822 979.061 609.822C981.418 609.822 983.309 611.35 983.309 613.215C983.309 615.08 981.392 616.609 979.061 616.609Z",
    fill: "url(#paint68_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1098.16 576.018C1099.84 574.697 1099.84 572.548 1098.16 571.227C1096.5 569.906 1093.78 569.906 1092.12 571.227C1090.44 572.548 1090.44 574.697 1092.12 576.018C1093.78 577.339 1096.5 577.339 1098.16 576.018Z",
    fill: "url(#paint69_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1014.29 658.621H924.589L906.354 644.116H868.07V642.328H907.286L925.547 656.808H1013.36L1035.06 639.583H1080.08L1145.64 587.494L1147.24 588.763L1081.01 641.37H1036.02L1014.29 658.621Z",
    fill: "url(#paint70_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M868.278 646.603C865.921 646.603 864.004 645.075 864.004 643.21C864.004 641.345 865.921 639.816 868.278 639.816C870.635 639.816 872.552 641.345 872.552 643.21C872.552 645.075 870.635 646.603 868.278 646.603Z",
    fill: "url(#paint71_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1149.29 590.653C1150.97 589.332 1150.97 587.182 1149.29 585.861C1147.63 584.54 1144.91 584.54 1143.26 585.861C1141.6 587.182 1141.6 589.332 1143.26 590.653C1144.94 591.974 1147.63 591.974 1149.29 590.653Z",
    fill: "url(#paint72_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M980.796 676.622H928.371L907.623 660.149L909.229 658.854L929.329 674.809H980.796V676.622Z",
    fill: "url(#paint73_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M905.55 662.014C903.892 660.693 903.892 658.543 905.55 657.222C907.208 655.901 909.927 655.901 911.585 657.222C913.243 658.543 913.243 660.693 911.585 662.014C909.927 663.335 907.234 663.335 905.55 662.014Z",
    fill: "url(#paint74_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M980.59 679.11C982.947 679.11 984.864 677.581 984.864 675.716C984.864 673.851 982.947 672.323 980.59 672.323C978.233 672.323 976.342 673.851 976.342 675.716C976.342 677.581 978.233 679.11 980.59 679.11Z",
    fill: "url(#paint75_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1129.37 807.609H1065.6L1053.63 798.103H984.397L932.774 757.126H878.146V755.313H933.732L985.329 796.316H1054.59L1066.53 805.822H1129.37V807.609Z",
    fill: "url(#paint76_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M878.354 759.612C875.997 759.612 874.08 758.084 874.08 756.219C874.08 754.354 875.997 752.826 878.354 752.826C880.711 752.826 882.628 754.354 882.628 756.219C882.628 758.084 880.711 759.612 878.354 759.612Z",
    fill: "url(#paint77_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1129.14 810.095C1131.49 810.095 1133.41 808.567 1133.41 806.702C1133.41 804.837 1131.49 803.309 1129.14 803.309C1126.78 803.309 1124.86 804.837 1124.86 806.702C1124.86 808.567 1126.78 810.095 1129.14 810.095Z",
    fill: "url(#paint78_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1168.38 788.857H1067.8L1057.41 780.62H1000.15L955.438 745.108H892.004V743.321H956.371L1001.08 778.807H1058.35L1068.73 787.069H1168.38V788.857Z",
    fill: "url(#paint79_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M892.185 747.62C889.828 747.62 887.938 746.092 887.938 744.227C887.938 742.362 889.854 740.834 892.185 740.834C894.517 740.834 896.459 742.362 896.459 744.227C896.459 746.092 894.543 747.62 892.185 747.62Z",
    fill: "url(#paint80_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1168.17 791.368C1170.53 791.368 1172.45 789.84 1172.45 787.975C1172.45 786.11 1170.53 784.582 1168.17 784.582C1165.82 784.582 1163.9 786.11 1163.9 787.975C1163.9 789.84 1165.79 791.368 1168.17 791.368Z",
    fill: "url(#paint81_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1103.29 776.578L1073.79 753.111H1002.76V751.324H1074.72L1104.92 775.309L1103.29 776.578Z",
    fill: "url(#paint82_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1002.99 755.597C1000.64 755.597 998.721 754.069 998.721 752.204C998.721 750.339 1000.64 748.811 1002.99 748.811C1005.35 748.811 1007.27 750.339 1007.27 752.204C1007.27 754.069 1005.35 755.597 1002.99 755.597Z",
    fill: "url(#paint83_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1100.93 778.211C1102.59 779.532 1105.31 779.532 1106.97 778.211C1108.65 776.89 1108.65 774.74 1106.97 773.419C1105.31 772.098 1102.59 772.098 1100.93 773.419C1099.27 774.74 1099.27 776.89 1100.93 778.211Z",
    fill: "url(#paint84_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M904.825 399.496H816.732L776.454 367.507H686.574L663.651 385.742H561.131L527.743 359.218H398.129V357.897H528.442L561.804 384.421H662.952L685.901 366.186H777.128L817.432 398.175H904.152L952.459 359.814H1099.56V361.135H953.158L904.825 399.496Z",
    fill: "url(#paint85_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M398.311 361.55C396.238 361.55 394.555 360.203 394.555 358.545C394.555 356.887 396.238 355.566 398.311 355.566C400.383 355.566 402.066 356.913 402.066 358.545C402.066 360.177 400.383 361.55 398.311 361.55Z",
    fill: "url(#paint86_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1099.37 363.468C1101.45 363.468 1103.13 362.121 1103.13 360.489C1103.13 358.857 1101.45 357.484 1099.37 357.484C1097.3 357.484 1095.62 358.831 1095.62 360.489C1095.62 362.147 1097.3 363.468 1099.37 363.468Z",
    fill: "url(#paint87_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M296.62 759.821H192.856L118.984 701.153H73.7847L57.9067 713.741H6.05078V712.42H57.2332L73.0853 699.832H119.683L193.556 758.5H295.921L320.761 738.762H472.858L518.653 702.396H650.494L696.03 738.555H1017.14V739.876H695.331L649.795 703.717H519.352L473.557 740.083H321.434L296.62 759.821Z",
    fill: "url(#paint88_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M6.25774 716.072C4.18558 716.072 2.50195 714.725 2.50195 713.093C2.50195 711.461 4.18558 710.088 6.25774 710.088C8.32991 710.088 10.0394 711.435 10.0394 713.093C10.0394 714.751 8.35581 716.072 6.25774 716.072Z",
    fill: "url(#paint89_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1016.93 742.207C1019 742.207 1020.69 740.86 1020.69 739.228C1020.69 737.596 1019 736.223 1016.93 736.223C1014.86 736.223 1013.17 737.57 1013.17 739.228C1013.17 740.886 1014.86 742.207 1016.93 742.207Z",
    fill: "url(#paint90_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M929.175 816.105H742.11L672.019 760.416H507.359V759.095H672.718L742.809 814.784H929.175V816.105Z",
    fill: "url(#paint91_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M507.539 762.747C505.467 762.747 503.783 761.4 503.783 759.742C503.783 758.085 505.467 756.764 507.539 756.764C509.611 756.764 511.321 758.111 511.321 759.742C511.321 761.374 509.611 762.747 507.539 762.747Z",
    fill: "url(#paint92_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M928.992 818.437C931.064 818.437 932.748 817.09 932.748 815.432C932.748 813.775 931.064 812.454 928.992 812.454C926.92 812.454 925.236 813.801 925.236 815.432C925.236 817.064 926.92 818.437 928.992 818.437Z",
    fill: "url(#paint93_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M680.385 309.15V330.208H653.861V309.15H680.385ZM683.079 307H651.193V332.332H683.079V307Z",
    fill: "url(#paint94_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M722.837 309.15V330.208H696.313V309.15H722.837ZM725.505 307H693.619V332.332H725.505V307Z",
    fill: "url(#paint95_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M850.173 309.15V330.208H823.649V309.15H850.173ZM852.866 307H820.955V332.332H852.866V307Z",
    fill: "url(#paint96_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M680.385 341.554V362.638H653.861V341.554H680.385ZM683.079 339.43H651.193V364.762H683.079V339.43Z",
    fill: "url(#paint97_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M765.291 341.554V362.638H738.768V341.554H765.291ZM767.985 339.43H736.1V364.762H767.985V339.43Z",
    fill: "url(#paint98_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M807.745 341.554V362.638H781.221V341.554H807.745ZM810.413 339.43H778.527V364.762H810.413V339.43Z",
    fill: "url(#paint99_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M850.173 341.554V362.638H823.649V341.554H850.173ZM852.866 339.43H820.955V364.762H852.866V339.43Z",
    fill: "url(#paint100_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M8.30321 736.223V759.613H-21.1474V736.223H8.30321ZM10.5308 734.462H-23.375V761.4H10.5308V734.462Z",
    fill: "url(#paint101_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M53.4243 736.223V759.613H23.9737V736.223H53.4243ZM55.6519 734.462H21.7461V761.4H55.6519V734.462Z",
    fill: "url(#paint102_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M98.5454 736.223V759.613H69.0948V736.223H98.5454ZM100.773 734.462H66.8672V761.4H100.773V734.462Z",
    fill: "url(#paint103_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M143.667 736.223V759.613H114.216V736.223H143.667ZM145.894 734.462H111.988V761.4H145.894V734.462Z",
    fill: "url(#paint104_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M188.79 736.223V759.613H159.339V736.223H188.79ZM191.017 734.462H157.111V761.4H191.017V734.462Z",
    fill: "url(#paint105_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M233.911 736.223V759.613H204.46V736.223H233.911ZM236.138 734.462H202.232V761.4H236.138V734.462Z",
    fill: "url(#paint106_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M324.127 736.223V759.613H294.677V736.223H324.127ZM326.355 734.462H292.449V761.4H326.355V734.462Z",
    fill: "url(#paint107_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M369.274 736.223V759.613H339.798V736.223H369.274ZM371.476 734.462H337.57V761.4H371.476V734.462Z",
    fill: "url(#paint108_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M414.396 736.223V759.613H384.919V736.223H414.396ZM416.597 734.462H382.691V761.4H416.597V734.462Z",
    fill: "url(#paint109_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M459.518 736.223V759.613H430.042V736.223H459.518ZM461.746 734.462H427.84V761.4H461.746V734.462Z",
    fill: "url(#paint110_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M504.639 736.223V759.613H475.188V736.223H504.639ZM506.867 734.462H472.961V761.4H506.867V734.462Z",
    fill: "url(#paint111_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M549.735 736.223V759.613H520.284V736.223H549.735ZM551.962 734.462H518.057V761.4H551.962V734.462Z",
    fill: "url(#paint112_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M594.856 736.223V759.613H565.405V736.223H594.856ZM597.084 734.462H563.178V761.4H597.084V734.462Z",
    fill: "url(#paint113_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M685.098 736.223V759.613H655.648V736.223H685.098ZM687.326 734.462H653.42V761.4H687.326V734.462Z",
    fill: "url(#paint114_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M730.219 736.223V759.613H700.769V736.223H730.219ZM732.447 734.462H698.541V761.4H732.447V734.462Z",
    fill: "url(#paint115_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M775.34 736.223V759.613H745.89V736.223H775.34ZM777.568 734.462H743.662V761.4H777.568V734.462Z",
    fill: "url(#paint116_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M8.30321 770.672V794.062H-21.1474V770.672H8.30321ZM10.5308 768.911H-23.375V795.849H10.5308V768.911Z",
    fill: "url(#paint117_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M98.5454 770.672V794.062H69.0948V770.672H98.5454ZM100.773 768.911H66.8672V795.849H100.773V768.911Z",
    fill: "url(#paint118_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M143.667 770.672V794.062H114.216V770.672H143.667ZM145.894 768.911H111.988V795.849H145.894V768.911Z",
    fill: "url(#paint119_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M188.79 770.672V794.062H159.339V770.672H188.79ZM191.017 768.911H157.111V795.849H191.017V768.911Z",
    fill: "url(#paint120_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M233.911 770.672V794.062H204.46V770.672H233.911ZM236.138 768.911H202.232V795.849H236.138V768.911Z",
    fill: "url(#paint121_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M279.032 770.672V794.062H249.581V770.672H279.032ZM281.259 768.911H247.354V795.849H281.259V768.911Z",
    fill: "url(#paint122_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M324.127 770.672V794.062H294.677V770.672H324.127ZM326.355 768.911H292.449V795.849H326.355V768.911Z",
    fill: "url(#paint123_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M369.274 770.672V794.062H339.798V770.672H369.274ZM371.476 768.911H337.57V795.849H371.476V768.911Z",
    fill: "url(#paint124_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M414.396 770.672V794.062H384.919V770.672H414.396ZM416.597 768.911H382.691V795.849H416.597V768.911Z",
    fill: "url(#paint125_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M459.518 770.672V794.062H430.042V770.672H459.518ZM461.746 768.911H427.84V795.849H461.746V768.911Z",
    fill: "url(#paint126_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M504.639 770.672V794.062H475.188V770.672H504.639ZM506.867 768.911H472.961V795.849H506.867V768.911Z",
    fill: "url(#paint127_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M549.735 770.672V794.062H520.284V770.672H549.735ZM551.962 768.911H518.057V795.849H551.962V768.911Z",
    fill: "url(#paint128_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M594.856 770.672V794.062H565.405V770.672H594.856ZM597.084 768.911H563.178V795.849H597.084V768.911Z",
    fill: "url(#paint129_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M639.977 770.672V794.062H610.526V770.672H639.977ZM642.205 768.911H608.299V795.849H642.205V768.911Z",
    fill: "url(#paint130_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M685.098 770.672V794.062H655.648V770.672H685.098ZM687.326 768.911H653.42V795.849H687.326V768.911Z",
    fill: "url(#paint131_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M775.34 770.672V794.062H745.89V770.672H775.34ZM777.568 768.911H743.662V795.849H777.568V768.911Z",
    fill: "url(#paint132_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M820.461 770.672V794.062H790.985V770.672H820.461ZM822.689 768.911H788.783V795.849H822.689V768.911Z",
    fill: "url(#paint133_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M-163.998 671.39H-309.723V668.904H-165.293L-148.456 655.538H-96.5228L-41.2995 611.66H225.414L293.407 557.654L295.609 559.416L226.709 614.147H-39.9785L-95.2277 658.025H-147.187L-163.998 671.39Z",
    fill: "url(#paint134_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M290.168 555.401C292.448 553.588 296.152 553.588 298.457 555.401C300.762 557.214 300.762 560.167 298.457 561.98C296.152 563.793 292.448 563.793 290.168 561.98C287.863 560.167 287.863 557.214 290.168 555.401Z",
    fill: "url(#paint135_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M28.5839 725.111H-127.01V722.624H27.2888L97.1467 667.142H362.565L463.557 586.949H842.789V589.436H464.826L363.86 669.629H98.4418L28.5839 725.111Z",
    fill: "url(#paint136_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M842.479 592.855C845.717 592.855 848.359 590.757 848.359 588.193C848.359 585.628 845.717 583.53 842.479 583.53C839.241 583.53 836.625 585.628 836.625 588.193C836.625 590.757 839.241 592.855 842.479 592.855Z",
    fill: "url(#paint137_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M39.8774 614.25L37.6758 612.514L113.025 552.655H244.452L289.858 516.573H663.729V519.06H291.153L245.773 555.116H114.32L39.8774 614.25Z",
    fill: "url(#paint138_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M663.418 522.479C666.656 522.479 669.272 520.381 669.272 517.817C669.272 515.252 666.63 513.154 663.418 513.154C660.206 513.154 657.564 515.226 657.564 517.817C657.564 520.407 660.181 522.479 663.418 522.479Z",
    fill: "url(#paint139_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M119.372 613.654L117.17 611.893L148.589 586.949H198.891V589.436H149.884L119.372 613.654Z",
    fill: "url(#paint140_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M198.606 592.855C201.844 592.855 204.46 590.757 204.46 588.193C204.46 585.628 201.818 583.53 198.606 583.53C195.394 583.53 192.752 585.628 192.752 588.193C192.752 590.757 195.368 592.855 198.606 592.855Z",
    fill: "url(#paint141_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M410.432 632.304H335.912L304.467 607.335L306.668 605.573L337.181 629.818H410.432V632.304Z",
    fill: "url(#paint142_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M309.906 603.32C307.627 601.507 303.897 601.507 301.618 603.32C299.312 605.133 299.312 608.086 301.618 609.899C303.897 611.712 307.627 611.712 309.906 609.899C312.212 608.086 312.212 605.133 309.906 603.32Z",
    fill: "url(#paint143_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M401.963 692.837H247.017L217.852 669.68L220.053 667.919L248.286 690.35H400.668L497.179 613.68H638.32V616.167H498.5L401.963 692.837Z",
    fill: "url(#paint144_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M638.034 619.586C641.271 619.586 643.887 617.488 643.887 614.924C643.887 612.359 641.245 610.261 638.034 610.261C634.822 610.261 632.18 612.359 632.18 614.924C632.18 617.488 634.796 619.586 638.034 619.586Z",
    fill: "url(#paint145_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M577.345 551.593H377.821L336.715 518.956L338.917 517.195L379.117 549.132H577.345V551.593Z",
    fill: "url(#paint146_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M577.06 555.012C580.297 555.012 582.913 552.914 582.913 550.349C582.913 547.785 580.271 545.687 577.06 545.687C573.848 545.687 571.18 547.785 571.18 550.349C571.18 552.914 573.822 555.012 577.06 555.012Z",
    fill: "url(#paint147_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M598.015 588.555L595.787 586.794L624.202 564.259H778.008V566.72H625.497L598.015 588.555Z",
    fill: "url(#paint148_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M826.472 671.416L791.841 643.908H567.685L532.303 615.804L534.504 614.043L568.98 641.421H793.136L828.7 669.681L826.472 671.416Z",
    fill: "url(#paint149_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M-227.328 658.024H-288.897L-321.119 632.433L-318.917 630.672L-287.602 655.538H-228.597L-108.593 560.218H-20.966L72.385 486.061H196.352V488.547H73.6801L-19.6709 562.705H-107.298L-227.328 658.024Z",
    fill: "url(#paint150_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M149.883 533.435H16.5137V530.949H148.588L176.2 509.01H252.093L264.992 498.778L267.22 500.514L253.362 511.496H177.495L149.883 533.435Z",
    fill: "url(#paint151_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M73.6547 586.898H30.4759L9.83203 570.502L12.0337 568.74L31.7452 584.437H73.6547V586.898Z",
    fill: "url(#paint152_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M712.995 511.419L690.227 493.34H444.805L410.848 466.35H265.433L209.381 510.876L207.18 509.14L264.138 463.889H412.143L446.1 490.853H691.522L715.171 509.658L712.995 511.419Z",
    fill: "url(#paint153_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M401.989 594.02L387.976 582.883H265.434V580.396H389.271L404.217 592.259L401.989 594.02Z",
    fill: "url(#paint154_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M408.309 492.64H336.793L303.354 466.065L305.555 464.329L338.088 490.179H408.309V492.64Z",
    fill: "url(#paint155_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M551.598 568.871H462.132L440.4 551.62L442.628 549.859L463.427 566.384H551.598V568.871Z",
    fill: "url(#paint156_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M502.307 492.743L500.105 490.982L554.707 447.622H784.588L826.497 414.338L828.699 416.099L785.883 450.109H556.002L502.307 492.743Z",
    fill: "url(#paint157_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M838.838 268.347C1161.21 268.347 1422.54 187.483 1422.54 87.7323C1422.54 -12.0187 1161.21 -92.8828 838.838 -92.8828C516.467 -92.8828 255.135 -12.0187 255.135 87.7323C255.135 187.483 516.467 268.347 838.838 268.347Z",
    fill: "url(#paint158_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M971.017 235.322C1427.21 235.322 1797.03 207.71 1797.03 173.649C1797.03 139.588 1427.21 111.977 971.017 111.977C514.82 111.977 145 139.588 145 173.649C145 207.71 514.82 235.322 971.017 235.322Z",
    fill: "url(#paint159_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1147.23 74.5217H1073.59L1030.18 40.0461H966.744L930.921 68.4866H743.183L721.192 51.0027H662.99V49.1895H722.125L744.141 66.6734H929.989L965.811 38.233H1031.14L1074.52 72.7086H1146.3L1210.72 21.552H1376.62L1423.35 -15.5656H1442.15L1474.42 -41.2087H1532.81L1605.44 -98.8926L1607.04 -97.6234L1533.74 -39.3955H1475.36L1443.11 -13.7784H1424.28L1377.55 23.3393H1211.65L1147.23 74.5217Z",
    fill: "url(#paint160_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M663.198 53.4895C660.841 53.4895 658.924 51.9612 658.924 50.0963C658.924 48.2313 660.841 46.7031 663.198 46.7031C665.555 46.7031 667.446 48.2313 667.446 50.0963C667.446 51.9612 665.529 53.4895 663.198 53.4895Z",
    fill: "url(#paint161_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1629.91 312.873L1580.65 273.735H1545.86L1485.22 225.557H1455.93L1415 258.09H1363.12L1312.02 217.476H1232.29L1193.1 248.61H1105.37L1060.15 212.684H975.291L965.578 220.403H910.562L886.913 201.624H764.733L746.472 216.103H655.504V214.316H745.54L763.8 199.811H887.871L911.494 218.59H964.619L974.358 210.871H1061.08L1106.3 246.797H1192.17L1231.33 215.689H1312.95L1364.05 256.277H1414.07L1455 223.77H1486.16L1546.79 271.922H1581.58L1631.52 311.604L1629.91 312.873Z",
    fill: "url(#paint162_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M655.711 218.616C653.354 218.616 651.438 217.114 651.438 215.223C651.438 213.332 653.354 211.83 655.711 211.83C658.068 211.83 659.985 213.358 659.985 215.223C659.985 217.088 658.068 218.616 655.711 218.616Z",
    fill: "url(#paint163_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1799.99 245.631L1759.89 213.771H1593.06L1545.16 175.721H1478.02L1441.22 146.478H1388.2L1360.69 168.339H1310.36L1284.87 148.058H1222.6L1206.21 161.086H1135.06L1091.98 126.87H994.588L955.735 157.719H888.804L838.917 118.115H667.652V116.328H839.875L889.737 155.932H954.803L993.656 125.057H1092.91L1135.99 159.273H1205.28L1221.65 146.27H1285.81L1311.32 166.526H1359.76L1387.26 144.665H1442.15L1478.98 173.908H1546.09L1593.99 211.958H1760.82L1801.59 244.336L1799.99 245.631Z",
    fill: "url(#paint164_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M667.885 120.628C665.528 120.628 663.611 119.1 663.611 117.235C663.611 115.37 665.528 113.842 667.885 113.842C670.242 113.842 672.159 115.37 672.159 117.235C672.159 119.1 670.242 120.628 667.885 120.628Z",
    fill: "url(#paint165_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1197.79 134.77H1141.95L1104.15 104.75H977.986L944.054 131.714H901.445L847.595 88.9235H743.676L718.395 68.8494H668.611V67.0621H719.328L744.608 87.1362H848.527L902.377 129.901H943.096L977.053 102.937H1105.09L1142.9 132.957H1196.83L1227.11 108.92H1323.26L1351.21 131.118H1464.63L1531.67 77.8892H1665.01L1693.3 55.4321L1694.88 56.7013L1665.94 79.7024H1532.6L1465.57 132.931H1350.25L1322.3 110.733H1228.04L1197.79 134.77Z",
    fill: "url(#paint166_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M668.817 71.3362C666.46 71.3362 664.543 69.8079 664.543 67.943C664.543 66.078 666.46 64.5498 668.817 64.5498C671.174 64.5498 673.091 66.0521 673.091 67.943C673.091 69.8338 671.174 71.3362 668.817 71.3362Z",
    fill: "url(#paint167_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M894.192 143.318L849.226 107.625H740.333L710.753 84.132H671.227V82.3188H711.711L741.292 105.812H850.158L895.797 142.049L894.192 143.318Z",
    fill: "url(#paint168_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M671.434 86.6184C669.077 86.6184 667.16 85.0901 667.16 83.2252C667.16 81.3602 669.077 79.832 671.434 79.832C673.791 79.832 675.682 81.3602 675.682 83.2252C675.682 85.0901 673.765 86.6184 671.434 86.6184Z",
    fill: "url(#paint169_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M891.808 144.975C893.465 146.296 896.185 146.296 897.869 144.975C899.527 143.654 899.527 141.505 897.869 140.184C896.185 138.863 893.491 138.863 891.808 140.184C890.15 141.505 890.15 143.654 891.808 144.975Z",
    fill: "url(#paint170_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1188.8 117.494H1138.29L1099.72 86.8776H974.488L940.815 113.608H912.815L880.723 88.1468L882.329 86.8517L913.748 111.821H939.883L973.556 85.0645H1100.71L1139.25 115.707H1187.87L1225.25 86.0228H1331.57V87.8101H1226.18L1188.8 117.494Z",
    fill: "url(#paint171_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M878.65 90.0116C876.992 88.6906 876.992 86.5408 878.65 85.2198C880.333 83.8988 883.027 83.8988 884.685 85.2198C886.343 86.5408 886.343 88.6906 884.685 90.0116C883.027 91.3326 880.307 91.3326 878.65 90.0116Z",
    fill: "url(#paint172_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M948.378 85.1163H917.943V83.3291H947.42L970.084 65.3271H1034.48V67.1144H971.017L948.378 85.1163Z",
    fill: "url(#paint173_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M918.178 87.6018C915.821 87.6018 913.93 86.0735 913.93 84.2086C913.93 82.3436 915.821 80.8154 918.178 80.8154C920.535 80.8154 922.451 82.3436 922.451 84.2086C922.451 86.0735 920.535 87.6018 918.178 87.6018Z",
    fill: "url(#paint174_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1034.27 69.6008C1036.63 69.6008 1038.54 68.0985 1038.54 66.2076C1038.54 64.3168 1036.65 62.8145 1034.27 62.8145C1031.89 62.8145 1030.02 64.3427 1030.02 66.2076C1030.02 68.0726 1031.91 69.6008 1034.27 69.6008Z",
    fill: "url(#paint175_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1161.79 95.5807L1160.18 94.3115L1221.85 45.3307H1414.46L1468.6 2.33328H1578.14L1622.19 -32.6863H1678.84L1720.36 -65.6855H1797.37V-63.8724H1721.32L1679.78 -30.8732H1623.13L1579.07 4.12051H1469.53L1415.42 47.1179H1222.81L1161.79 95.5807Z",
    fill: "url(#paint176_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1164.17 97.2123C1162.49 98.5333 1159.79 98.5333 1158.11 97.2123C1156.42 95.8913 1156.42 93.7414 1158.11 92.4204C1159.77 91.0994 1162.49 91.0994 1164.17 92.4204C1165.83 93.7414 1165.83 95.8913 1164.17 97.2123Z",
    fill: "url(#paint177_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1186.96 101.589L1185.38 100.294L1240.11 56.8302H1346.18L1377.96 82.0588H1439.64L1486.7 44.708H1609.79V46.4952H1487.63L1440.6 83.8719H1377.01L1345.22 58.6174H1241.07L1186.96 101.589Z",
    fill: "url(#paint178_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1189.35 103.221C1187.66 104.542 1184.97 104.542 1183.28 103.221C1181.63 101.9 1181.63 99.7502 1183.28 98.4292C1184.97 97.1082 1187.66 97.1082 1189.35 98.4292C1191 99.7502 1191 101.9 1189.35 103.221Z",
    fill: "url(#paint179_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1460.1 117.623H1367.27L1342.09 97.6263H1271.07V95.8131H1343.02L1368.2 115.81H1459.14L1519.57 67.813H1626.78V69.6261H1520.53L1460.1 117.623Z",
    fill: "url(#paint180_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1271.3 100.113C1268.92 100.113 1267.03 98.5853 1267.03 96.7203C1267.03 94.8554 1268.94 93.3271 1271.3 93.3271C1273.66 93.3271 1275.55 94.8554 1275.55 96.7203C1275.55 98.5853 1273.63 100.113 1271.3 100.113Z",
    fill: "url(#paint181_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1449.4 102.108H1374.18L1341.44 76.1283H1251.56V74.3152H1342.4L1375.12 100.321H1448.47L1503.23 56.8313H1637.3L1689.85 15.0771H1735.67V16.8903H1690.78L1638.23 58.6185H1504.16L1449.4 102.108Z",
    fill: "url(#paint182_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1251.77 78.6154C1249.41 78.6154 1247.52 77.0872 1247.52 75.2223C1247.52 73.3573 1249.44 71.8291 1251.77 71.8291C1254.1 71.8291 1256.04 73.3573 1256.04 75.2223C1256.04 77.0872 1254.15 78.6154 1251.77 78.6154Z",
    fill: "url(#paint183_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1404.07 35.1246H1226.38V33.3115H1403.14L1471.73 -21.1865H1542.88L1588.5 -57.4235H1661.2L1709.15 -95.4995L1710.75 -94.2303L1662.16 -55.6103H1589.45L1543.81 -19.3733H1472.69L1404.07 35.1246Z",
    fill: "url(#paint184_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1226.59 37.6115C1224.23 37.6115 1222.34 36.0833 1222.34 34.2184C1222.34 32.3534 1224.26 30.8252 1226.59 30.8252C1228.92 30.8252 1230.87 32.3534 1230.87 34.2184C1230.87 36.0833 1228.95 37.6115 1226.59 37.6115Z",
    fill: "url(#paint185_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M735.619 199.111H662.42V197.323H734.687L761.107 176.317H879.635V178.13H762.065L735.619 199.111Z",
    fill: "url(#paint186_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M662.627 201.598C660.27 201.598 658.354 200.07 658.354 198.205C658.354 196.34 660.27 194.812 662.627 194.812C664.984 194.812 666.901 196.34 666.901 198.205C666.901 200.07 664.984 201.598 662.627 201.598Z",
    fill: "url(#paint187_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M879.428 180.616C881.785 180.616 883.701 179.088 883.701 177.223C883.701 175.358 881.785 173.83 879.428 173.83C877.071 173.83 875.18 175.358 875.18 177.223C875.18 179.088 877.096 180.616 879.428 180.616Z",
    fill: "url(#paint188_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1755.8 238.094H1540.37L1500.07 206.079H1454.4L1422.95 231.048H1376.77L1333.88 196.987H1228.95L1181.26 234.882H1108.87L1070.79 204.628H921.62L902.09 189.113H802.16V187.326H903.049L922.553 202.815H1071.75L1109.82 233.069H1180.3L1227.99 195.2H1334.84L1377.7 229.261H1422.02L1453.44 204.292H1501L1541.3 236.306H1755.8V238.094Z",
    fill: "url(#paint189_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M802.368 191.599C800.01 191.599 798.094 190.071 798.094 188.206C798.094 186.341 800.01 184.813 802.368 184.813C804.725 184.813 806.616 186.341 806.616 188.206C806.616 190.071 804.699 191.599 802.368 191.599Z",
    fill: "url(#paint190_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1749.5 228.173H1586.86L1534.05 186.211H1464.71L1442.15 168.313H1399.28L1380.17 183.492H1300.7L1279.77 166.862H1260.24L1242.94 180.616H1134.38L1090.94 146.115H1015.08L983.605 171.11H909.162V169.323H982.672L1014.14 144.328H1091.88L1135.31 178.829H1242L1259.31 165.075H1280.7L1301.63 181.678H1379.21L1398.32 166.5H1443.11L1465.64 184.398H1535.01L1587.8 226.359H1749.5V228.173Z",
    fill: "url(#paint191_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M909.37 173.597C907.012 173.597 905.096 172.069 905.096 170.204C905.096 168.339 907.012 166.811 909.37 166.811C911.727 166.811 913.643 168.339 913.643 170.204C913.643 172.069 911.727 173.597 909.37 173.597Z",
    fill: "url(#paint192_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M865.803 167.122H757.325L734.687 149.12H671.227V147.307H735.619L758.283 165.309H865.803V167.122Z",
    fill: "url(#paint193_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M671.434 151.607C669.077 151.607 667.16 150.079 667.16 148.214C667.16 146.349 669.077 144.821 671.434 144.821C673.791 144.821 675.682 146.349 675.682 148.214C675.682 150.079 673.765 151.607 671.434 151.607Z",
    fill: "url(#paint194_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M865.569 169.609C867.926 169.609 869.817 168.081 869.817 166.216C869.817 164.351 867.9 162.823 865.569 162.823C863.238 162.823 861.295 164.351 861.295 166.216C861.295 168.081 863.212 169.609 865.569 169.609Z",
    fill: "url(#paint195_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M850.676 147.618H771.804L748.518 129.124H661.15V127.311H749.476L772.762 145.805H850.676V147.618Z",
    fill: "url(#paint196_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M661.358 131.61C659.001 131.61 657.084 130.107 657.084 128.216C657.084 126.326 659.001 124.823 661.358 124.823C663.715 124.823 665.632 126.351 665.632 128.216C665.632 130.081 663.715 131.61 661.358 131.61Z",
    fill: "url(#paint197_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M850.469 150.104C852.826 150.104 854.717 148.575 854.717 146.711C854.717 144.846 852.826 143.317 850.469 143.317C848.112 143.317 846.195 144.846 846.195 146.711C846.195 148.575 848.086 150.104 850.469 150.104Z",
    fill: "url(#paint198_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1185.54 206.882H1145.39L1092.19 164.61H1027.04L1005.03 182.12H922.994V180.307H1004.07L1026.11 162.823H1093.14L1146.32 205.069H1185.54V206.882Z",
    fill: "url(#paint199_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M923.201 184.606C920.844 184.606 918.953 183.077 918.953 181.212C918.953 179.348 920.87 177.819 923.201 177.819C925.532 177.819 927.475 179.348 927.475 181.212C927.475 183.077 925.584 184.606 923.201 184.606Z",
    fill: "url(#paint200_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1185.33 209.368C1187.69 209.368 1189.6 207.84 1189.6 205.975C1189.6 204.11 1187.69 202.582 1185.33 202.582C1182.97 202.582 1181.08 204.11 1181.08 205.975C1181.08 207.84 1182.97 209.368 1185.33 209.368Z",
    fill: "url(#paint201_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1123.61 212.088L1079.6 177.12H1037.74L1016.35 194.112H936.852V192.324H1015.41L1036.78 175.307H1080.56L1125.21 210.792L1123.61 212.088Z",
    fill: "url(#paint202_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M937.059 196.599C934.702 196.599 932.785 195.071 932.785 193.206C932.785 191.341 934.702 189.812 937.059 189.812C939.416 189.812 941.333 191.341 941.333 193.206C941.333 195.071 939.416 196.599 937.059 196.599Z",
    fill: "url(#paint203_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1121.25 213.72C1122.93 215.041 1125.63 215.041 1127.31 213.72C1128.99 212.399 1128.99 210.249 1127.31 208.928C1125.65 207.607 1122.93 207.607 1121.25 208.928C1119.59 210.249 1119.59 212.399 1121.25 213.72Z",
    fill: "url(#paint204_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M964.62 261.821H860.856L786.984 203.153H741.785L725.907 215.741H674.051V214.42H725.233L741.085 201.832H787.683L861.556 260.5H963.921L988.761 240.762H1140.86L1186.65 204.396H1318.49L1364.03 240.555H1685.14V241.876H1363.33L1317.79 205.717H1187.35L1141.56 242.083H989.434L964.62 261.821Z",
    fill: "url(#paint205_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M674.258 218.072C672.186 218.072 670.502 216.725 670.502 215.093C670.502 213.461 672.186 212.088 674.258 212.088C676.33 212.088 678.039 213.435 678.039 215.093C678.039 216.751 676.356 218.072 674.258 218.072Z",
    fill: "url(#paint206_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1597.17 318.105H1410.11L1340.02 262.416H1175.36V261.095H1340.72L1410.81 316.784H1597.17V318.105Z",
    fill: "url(#paint207_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1175.54 264.747C1173.47 264.747 1171.78 263.4 1171.78 261.742C1171.78 260.085 1173.47 258.764 1175.54 258.764C1177.61 258.764 1179.32 260.111 1179.32 261.742C1179.32 263.374 1177.61 264.747 1175.54 264.747Z",
    fill: "url(#paint208_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M676.303 238.223V261.613H646.853V238.223H676.303ZM678.531 236.462H644.625V263.4H678.531V236.462Z",
    fill: "url(#paint209_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M721.424 238.223V261.613H691.974V238.223H721.424ZM723.652 236.462H689.746V263.4H723.652V236.462Z",
    fill: "url(#paint210_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M766.545 238.223V261.613H737.095V238.223H766.545ZM768.773 236.462H734.867V263.4H768.773V236.462Z",
    fill: "url(#paint211_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M811.667 238.223V261.613H782.216V238.223H811.667ZM813.894 236.462H779.988V263.4H813.894V236.462Z",
    fill: "url(#paint212_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M856.79 238.223V261.613H827.339V238.223H856.79ZM859.017 236.462H825.111V263.4H859.017V236.462Z",
    fill: "url(#paint213_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M901.911 238.223V261.613H872.46V238.223H901.911ZM904.138 236.462H870.232V263.4H904.138V236.462Z",
    fill: "url(#paint214_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M992.127 238.223V261.613H962.677V238.223H992.127ZM994.355 236.462H960.449V263.4H994.355V236.462Z",
    fill: "url(#paint215_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1037.27 238.223V261.613H1007.8V238.223H1037.27ZM1039.48 236.462H1005.57V263.4H1039.48V236.462Z",
    fill: "url(#paint216_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1082.4 238.223V261.613H1052.92V238.223H1082.4ZM1084.6 236.462H1050.69V263.4H1084.6V236.462Z",
    fill: "url(#paint217_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1127.52 238.223V261.613H1098.04V238.223H1127.52ZM1129.75 236.462H1095.84V263.4H1129.75V236.462Z",
    fill: "url(#paint218_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1172.64 238.223V261.613H1143.19V238.223H1172.64ZM1174.87 236.462H1140.96V263.4H1174.87V236.462Z",
    fill: "url(#paint219_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1217.73 238.223V261.613H1188.28V238.223H1217.73ZM1219.96 236.462H1186.06V263.4H1219.96V236.462Z",
    fill: "url(#paint220_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1262.86 238.223V261.613H1233.41V238.223H1262.86ZM1265.08 236.462H1231.18V263.4H1265.08V236.462Z",
    fill: "url(#paint221_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M676.303 272.672V296.062H646.853V272.672H676.303ZM678.531 270.911H644.625V297.849H678.531V270.911Z",
    fill: "url(#paint222_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M766.545 272.672V296.062H737.095V272.672H766.545ZM768.773 270.911H734.867V297.849H768.773V270.911Z",
    fill: "url(#paint223_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M811.667 272.672V296.062H782.216V272.672H811.667ZM813.894 270.911H779.988V297.849H813.894V270.911Z",
    fill: "url(#paint224_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M856.79 272.672V296.062H827.339V272.672H856.79ZM859.017 270.911H825.111V297.849H859.017V270.911Z",
    fill: "url(#paint225_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M901.911 272.672V296.062H872.46V272.672H901.911ZM904.138 270.911H870.232V297.849H904.138V270.911Z",
    fill: "url(#paint226_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M947.032 272.672V296.062H917.581V272.672H947.032ZM949.259 270.911H915.354V297.849H949.259V270.911Z",
    fill: "url(#paint227_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M992.127 272.672V296.062H962.677V272.672H992.127ZM994.355 270.911H960.449V297.849H994.355V270.911Z",
    fill: "url(#paint228_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1037.27 272.672V296.062H1007.8V272.672H1037.27ZM1039.48 270.911H1005.57V297.849H1039.48V270.911Z",
    fill: "url(#paint229_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1082.4 272.672V296.062H1052.92V272.672H1082.4ZM1084.6 270.911H1050.69V297.849H1084.6V270.911Z",
    fill: "url(#paint230_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1127.52 272.672V296.062H1098.04V272.672H1127.52ZM1129.75 270.911H1095.84V297.849H1129.75V270.911Z",
    fill: "url(#paint231_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1172.64 272.672V296.062H1143.19V272.672H1172.64ZM1174.87 270.911H1140.96V297.849H1174.87V270.911Z",
    fill: "url(#paint232_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1217.73 272.672V296.062H1188.28V272.672H1217.73ZM1219.96 270.911H1186.06V297.849H1219.96V270.911Z",
    fill: "url(#paint233_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1262.86 272.672V296.062H1233.41V272.672H1262.86ZM1265.08 270.911H1231.18V297.849H1265.08V270.911Z",
    fill: "url(#paint234_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1307.98 272.672V296.062H1278.53V272.672H1307.98ZM1310.2 270.911H1276.3V297.849H1310.2V270.911Z",
    fill: "url(#paint235_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M504.002 173.39H358.277V170.904H502.707L519.544 157.538H571.477L626.7 113.66H893.414L961.407 59.6543L963.609 61.4156L894.709 116.147H628.021L572.772 160.025H520.813L504.002 173.39Z",
    fill: "url(#paint236_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M958.168 57.4009C960.448 55.5877 964.152 55.5877 966.457 57.4009C968.762 59.214 968.762 62.1669 966.457 63.98C964.152 65.7931 960.448 65.7931 958.168 63.98C955.863 62.1669 955.863 59.214 958.168 57.4009Z",
    fill: "url(#paint237_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M358.563 167.485C355.325 167.485 352.709 169.583 352.709 172.148C352.709 174.712 355.325 176.81 358.563 176.81C361.801 176.81 364.443 174.712 364.443 172.148C364.443 169.583 361.801 167.485 358.563 167.485Z",
    fill: "url(#paint238_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M696.584 227.111H540.99V224.624H695.289L765.147 169.142H1030.57L1131.56 88.9492H1510.79V91.4358H1132.83L1031.86 171.629H766.442L696.584 227.111Z",
    fill: "url(#paint239_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M707.877 116.25L705.676 114.514L781.025 54.6548H912.452L957.858 18.5732H1331.73V21.0598H959.153L913.773 57.1155H782.32L707.877 116.25Z",
    fill: "url(#paint240_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M787.372 115.654L785.17 113.893L816.589 88.9492H866.891V91.4358H817.884L787.372 115.654Z",
    fill: "url(#paint241_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M866.606 94.855C869.844 94.855 872.46 92.757 872.46 90.1927C872.46 87.6283 869.818 85.5303 866.606 85.5303C863.394 85.5303 860.752 87.6283 860.752 90.1927C860.752 92.757 863.368 94.855 866.606 94.855Z",
    fill: "url(#paint242_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1078.43 134.304H1003.91L972.467 109.335L974.668 107.573L1005.18 131.818H1078.43V134.304Z",
    fill: "url(#paint243_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M977.906 105.32C975.627 103.507 971.897 103.507 969.618 105.32C967.312 107.133 967.312 110.086 969.618 111.899C971.897 113.712 975.627 113.712 977.906 111.899C980.212 110.086 980.212 107.133 977.906 105.32Z",
    fill: "url(#paint244_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1069.96 194.837H915.017L885.852 171.68L888.053 169.919L916.286 192.35H1068.67L1165.18 115.68H1306.32V118.167H1166.5L1069.96 194.837Z",
    fill: "url(#paint245_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1245.35 53.5928H1045.82L1004.71 20.9562L1006.92 19.1948L1047.12 51.1321H1245.35V53.5928Z",
    fill: "url(#paint246_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1245.06 57.0118C1248.3 57.0118 1250.91 54.9137 1250.91 52.3494C1250.91 49.7851 1248.27 47.687 1245.06 47.687C1241.85 47.687 1239.18 49.7851 1239.18 52.3494C1239.18 54.9137 1241.82 57.0118 1245.06 57.0118Z",
    fill: "url(#paint247_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1266.01 90.5554L1263.79 88.7941L1292.2 66.2593H1446.01V68.72H1293.5L1266.01 90.5554Z",
    fill: "url(#paint248_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1494.47 173.416L1459.84 145.908H1235.68L1200.3 117.804L1202.5 116.043L1236.98 143.421H1461.14L1496.7 171.681L1494.47 173.416Z",
    fill: "url(#paint249_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M440.672 160.024H379.103L346.881 134.433L349.083 132.672L380.398 157.538H439.403L559.407 62.2181H647.034L740.385 -11.9395H864.352V-9.45286H741.68L648.329 64.7048H560.702L440.672 160.024Z",
    fill: "url(#paint250_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M531.486 134.796H471.781V132.335H530.19L582.901 90.4517H635.741V92.9382H584.196L531.486 134.796Z",
    fill: "url(#paint251_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M817.883 35.4353H684.514V32.9487H816.588L844.2 11.0096H920.093L932.992 0.77832L935.22 2.51377L921.362 13.4962H845.495L817.883 35.4353Z",
    fill: "url(#paint252_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M741.655 88.8976H698.476L677.832 72.5016L680.034 70.7402L699.745 86.4369H741.655V88.8976Z",
    fill: "url(#paint253_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1381 13.4194L1358.23 -4.6602H1112.81L1078.85 -31.6502H933.433L877.381 12.8755L875.18 11.1401L932.138 -34.1108H1080.14L1114.1 -7.1468H1359.52L1383.17 11.6581L1381 13.4194Z",
    fill: "url(#paint254_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1069.99 96.0205L1055.98 84.8826H933.434V82.396H1057.27L1072.22 94.2591L1069.99 96.0205Z",
    fill: "url(#paint255_radial_114_2)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1219.6 70.871H1130.13L1108.4 53.6202L1110.63 51.8589L1131.43 68.3844H1219.6V70.871Z",
    fill: "url(#paint256_radial_114_2)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(171.182 571.283) scale(583.5 179.288)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A72B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#054073"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#011237"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#000020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(307.125 685.041) scale(824.723 61.9357)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A72B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#054073"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#011237"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#000020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(468.77 483.838) scale(343.503 271.187)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(941.105 398.168) scale(4.28163 3.38022)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(477.303 751.436) scale(349.675 276.059)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(965.672 807.035) scale(4.28163 3.38023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(568.664 676.324) scale(406.133 320.631)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.361253 612.8) scale(4.28162 3.38021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1136.2 739.989) scale(4.28157 3.38023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(515.632 590.747) scale(365.561 288.601)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.30533 563.682) scale(4.28162 3.38022)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1029.22 551.98) scale(4.28155 3.38023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(116.319 608.417) scale(84.1558 66.4388)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.93444 578.904) scale(4.28162 3.38021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(227.935 638.046) scale(4.28161 3.38021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(439.832 596.901) scale(160.487 126.7)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(214.736 583.287) scale(4.28163 3.38021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(665.634 582.587) scale(4.28164 3.38021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(309.523 570.932) scale(42.2551 33.3593)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(251.353 579.906) scale(4.28162 3.38021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(367.753 561.957) scale(4.28162 3.38022)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(813.454 510.881) scale(237.083 187.171)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(494.962 590.467) scale(4.28161 3.38023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1132.71 431.41) scale(4.2816 3.38021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(732.045 568.856) scale(152.603 120.476)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(520.208 596.458) scale(4.28161 3.38023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(944.619 541.419) scale(4.2816 3.38021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(895.778 517.011) scale(129.57 102.292)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(722.181 561.957) scale(4.28158 3.38022)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1068.64 471.928) scale(4.28163 3.38022)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(783.542 588.368) scale(128.035 101.08)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(605.426 592.355) scale(4.28162 3.38021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(961.657 564.451) scale(4.2816 3.38023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(828.336 554.381) scale(175.959 138.915)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(585.849 570.933) scale(4.28162 3.38021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1070.85 511.906) scale(4.2816 3.38021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(803.236 465.888) scale(181.334 143.158)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(560.602 530.089) scale(4.28162 3.38021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1045.13 401.548) scale(4.28155 3.38022)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(103.799 683.038) scale(77.6891 61.3335)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(212.493 672.594) scale(4.28162 3.38023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(613.132 707.959) scale(338.838 267.504)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(135.216 683.551) scale(4.2816 3.38021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1091.05 732.367) scale(4.2816 3.38021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(663.626 681.569) scale(300.274 237.058)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(242.493 665.601) scale(4.2816 3.38021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1084.73 722.458) scale(4.28166 3.38021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(101.26 652.663) scale(69.5393 54.8994)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.93444 643.689) scale(4.28162 3.38023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(198.584 661.615) scale(4.28158 3.38023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(88.6508 632.965) scale(67.7971 53.524)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(183.437 642.195) scale(4.28162 3.38023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(387.802 680.195) scale(95.1404 75.1108)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(256.401 676.558) scale(4.28162 3.38021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(519.233 701.245) scale(4.28162 3.38021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(364.504 689.006) scale(68.7715 54.2933)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(270.279 688.54) scale(4.2816 3.38021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(457.992 706.56) scale(4.28161 3.38023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(933.28 603.942) scale(95.3766 75.2973)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(809.289 643.292) scale(4.28157 3.38023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1057.27 564.613) scale(4.28155 3.38021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(999.305 686.628) scale(127.267 100.474)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(824.438 654.644) scale(4.2816 3.38023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1173.41 718.776) scale(4.28157 3.38023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint64_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(968.744 623.616) scale(88.8213 70.122)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint65_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(847.145 640.308) scale(4.28165 3.38023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1090.34 602.659) scale(4.28163 3.38023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1040.79 591.144) scale(45.4737 35.9002)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint68_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(982.209 610.796) scale(4.28158 3.38021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1098.61 571.328) scale(4.28163 3.38023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint70_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1010.88 620.586) scale(103.94 82.0578)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(871.123 640.705) scale(4.28167 3.38023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint72_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1149.9 585.921) scale(4.28163 3.38021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint73_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(947.277 665.135) scale(27.1366 21.4236)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint74_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(911.546 657.046) scale(4.28155 3.38023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint75_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(983.745 673.085) scale(4.28166 3.38023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint76_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1006.98 778.477) scale(92.0694 72.6864)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint77_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(881.222 753.3) scale(4.2816 3.38021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint78_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1132.71 803.63) scale(4.2816 3.38021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint79_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1033.47 763.138) scale(100.072 79.0039)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint80_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(895.13 741.342) scale(4.28166 3.38023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint81_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1171.84 784.934) scale(4.2816 3.38023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint82_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1057.18 761.016) scale(37.9144 29.9324)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint83_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1006.22 749.314) scale(4.2816 3.38023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint84_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1107.44 772.836) scale(4.28163 3.38023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint85_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(751.355 377.07) scale(249.367 196.869)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint86_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(399.88 357.022) scale(3.77966 2.98392)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint87_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1102.83 358.912) scale(3.77958 2.98391)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint88_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.476 727.005) scale(359.449 283.775)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint89_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.76956 710.314) scale(3.77961 2.98391)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint90_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1020.18 736.376) scale(3.77958 2.98393)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint91_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(720.706 784.562) scale(151.687 119.753)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint92_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(509.4 756.821) scale(3.77963 2.98391)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint93_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(932.01 812.327) scale(3.77966 2.98391)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint94_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(669.445 318.254) scale(16.0044 12.635)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint95_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(711.994 318.254) scale(15.9748 12.6117)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint96_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(839.676 318.254) scale(16.0044 12.635)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint97_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(669.445 350.565) scale(16.0044 12.635)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint98_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(754.545 350.565) scale(15.9748 12.6117)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint99_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(797.125 350.565) scale(16.0043 12.635)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint100_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(839.676 350.565) scale(16.0044 12.635)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint101_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-5.95794 745.048) scale(17.0083 13.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint102_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.2792 745.048) scale(17.0083 13.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint103_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.5164 745.048) scale(17.0083 13.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint104_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(129.783 745.048) scale(17.0083 13.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint105_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(175.022 745.048) scale(17.0083 13.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint106_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(220.259 745.048) scale(17.0083 13.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint107_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(310.734 745.048) scale(17.0083 13.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint108_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(355.971 745.048) scale(17.0083 13.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint109_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(401.208 745.048) scale(17.0083 13.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint110_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(446.476 745.048) scale(17.0083 13.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint111_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(491.714 745.048) scale(17.0083 13.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint112_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(536.951 745.048) scale(17.0083 13.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint113_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(582.188 745.048) scale(17.0083 13.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint114_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(672.692 745.048) scale(17.0083 13.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint115_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(717.929 745.048) scale(17.0083 13.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint116_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(763.166 745.048) scale(17.0083 13.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint117_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-5.95794 779.386) scale(17.0083 13.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint118_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.5164 779.386) scale(17.0083 13.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint119_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(129.783 779.386) scale(17.0083 13.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint120_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(175.022 779.386) scale(17.0083 13.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint121_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(220.259 779.386) scale(17.0083 13.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint122_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(265.496 779.386) scale(17.0083 13.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint123_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(310.734 779.386) scale(17.0083 13.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint124_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(355.971 779.386) scale(17.0083 13.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint125_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(401.208 779.386) scale(17.0083 13.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint126_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(446.476 779.386) scale(17.0083 13.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint127_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(491.714 779.386) scale(17.0083 13.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint128_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(536.951 779.386) scale(17.0083 13.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint129_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(582.188 779.386) scale(17.0083 13.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint130_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(627.455 779.386) scale(17.0083 13.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint131_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(672.692 779.386) scale(17.0083 13.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint132_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(763.166 779.386) scale(17.0083 13.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint133_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(808.433 779.386) scale(17.0084 13.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint134_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-6.57833 612.1) scale(220.518 174.093)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint135_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(295.585 556.455) scale(5.87616 4.63906)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint136_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(359.366 653.455) scale(349.291 275.756)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint137_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(845.285 585.851) scale(5.87618 4.63907)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint138_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(352.132 563.168) scale(226.187 178.569)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint139_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(665.724 515.729) scale(5.87613 4.63906)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint140_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(158.929 597.927) scale(31.3296 24.7339)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint141_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199.619 585.851) scale(5.87617 4.63907)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint142_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(358.894 616.506) scale(39.4204 31.1213)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint143_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(307.101 604.221) scale(5.87616 4.63907)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint144_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(429.734 650.705) scale(153.193 120.942)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint145_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(640.24 612.497) scale(5.87613 4.63905)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint146_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(458.759 532.257) scale(86.6952 68.4437)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint147_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(579.116 548.155) scale(5.87614 4.63907)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint148_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(689.257 574.102) scale(65.4939 51.7057)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint149_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(682.821 640.214) scale(108.162 85.3914)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint150_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-62.0617 569.766) scale(198.873 157.005)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint151_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(142.717 514.027) scale(90.2091 71.2178)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint152_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.351 575.524) scale(24.0361 18.9758)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint153_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(462.923 485.657) scale(181.334 143.158)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint154_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(336.217 584.872) scale(49.5781 39.1406)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint155_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(357.27 476.519) scale(39.3022 31.0281)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint156_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(497.854 557.132) scale(40.3357 31.844)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint157_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(666.698 451.668) scale(121.627 96.0216)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint158_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(839.182 73.2828) scale(583.5 179.288)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A72B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#054073"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#011237"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#000020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint159_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(975.125 187.041) scale(824.723 61.9357)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A72B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#054073"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#011237"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#000020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint160_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1136.77 -14.1617) scale(343.503 271.187)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint161_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(663.667 47.8946) scale(4.2816 3.38022)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint162_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1145.3 253.436) scale(349.675 276.059)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint163_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(656.166 212.454) scale(4.28162 3.38021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint164_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1236.66 178.324) scale(406.133 320.631)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint165_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(668.361 114.8) scale(4.28162 3.38021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint166_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1183.63 92.7467) scale(365.561 288.601)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint167_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(669.305 65.6817) scale(4.28162 3.38022)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint168_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(784.319 110.417) scale(84.1558 66.4388)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint169_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(671.934 80.9044) scale(4.28162 3.38021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint170_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(895.935 140.046) scale(4.28161 3.38021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint171_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1107.83 98.9013) scale(160.487 126.7)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint172_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(882.736 85.2871) scale(4.28163 3.38021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint173_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(977.523 72.932) scale(42.2551 33.3593)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint174_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(919.353 81.9059) scale(4.28162 3.38021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint175_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1035.75 63.9567) scale(4.28162 3.38022)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint176_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1481.45 12.8806) scale(237.083 187.171)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint177_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1162.96 92.4671) scale(4.28161 3.38023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint178_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1400.04 70.8561) scale(152.603 120.476)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint179_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1188.21 98.4577) scale(4.28161 3.38023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint180_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1451.54 90.3685) scale(128.035 101.08)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint181_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1273.43 94.3555) scale(4.28162 3.38021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint182_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1496.34 56.3806) scale(175.959 138.915)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint183_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1253.85 72.9325) scale(4.28162 3.38021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint184_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1471.24 -32.112) scale(181.334 143.158)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint185_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1228.6 32.0892) scale(4.28162 3.38021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint186_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(771.799 185.038) scale(77.6891 61.3335)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint187_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(663.106 195.506) scale(4.28162 3.38021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint188_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(880.493 174.594) scale(4.28162 3.38023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint189_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1281.13 209.959) scale(338.838 267.504)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint190_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(803.216 185.551) scale(4.2816 3.38021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint191_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1331.63 183.569) scale(300.274 237.058)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint192_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(910.493 167.601) scale(4.2816 3.38021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint193_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(769.26 154.663) scale(69.5393 54.8994)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint194_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(671.934 145.689) scale(4.28162 3.38023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint195_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(866.584 163.615) scale(4.28158 3.38023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint196_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(756.651 134.965) scale(67.7971 53.524)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint197_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(661.835 125.756) scale(4.28162 3.38023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint198_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(851.437 144.195) scale(4.28162 3.38023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint199_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1055.8 182.195) scale(95.1404 75.1108)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint200_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(924.401 178.558) scale(4.28162 3.38021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint201_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1187.23 203.245) scale(4.28162 3.38021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint202_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1032.5 191.006) scale(68.7715 54.2933)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint203_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(938.279 190.54) scale(4.2816 3.38021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint204_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1125.99 208.56) scale(4.28161 3.38023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint205_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1181.48 229.005) scale(359.449 283.775)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint206_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(674.77 212.314) scale(3.77961 2.98391)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint207_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1388.71 286.562) scale(151.687 119.753)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint208_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1177.4 258.821) scale(3.77963 2.98391)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint209_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(662.042 247.048) scale(17.0083 13.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint210_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(707.279 247.048) scale(17.0083 13.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint211_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(752.516 247.048) scale(17.0083 13.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint212_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(797.783 247.048) scale(17.0083 13.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint213_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(843.022 247.048) scale(17.0083 13.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint214_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(888.259 247.048) scale(17.0083 13.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint215_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(978.734 247.048) scale(17.0083 13.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint216_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1023.97 247.048) scale(17.0083 13.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint217_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1069.21 247.048) scale(17.0083 13.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint218_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1114.48 247.048) scale(17.0083 13.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint219_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1159.71 247.048) scale(17.0083 13.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint220_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1204.95 247.048) scale(17.0083 13.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint221_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1250.19 247.048) scale(17.0083 13.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint222_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(662.042 281.386) scale(17.0083 13.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint223_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(752.516 281.386) scale(17.0083 13.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint224_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(797.783 281.386) scale(17.0083 13.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint225_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(843.022 281.386) scale(17.0083 13.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint226_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(888.259 281.386) scale(17.0083 13.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint227_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(933.496 281.386) scale(17.0083 13.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint228_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(978.734 281.386) scale(17.0083 13.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint229_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1023.97 281.386) scale(17.0083 13.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint230_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1069.21 281.386) scale(17.0083 13.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint231_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1114.48 281.386) scale(17.0083 13.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint232_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1159.71 281.386) scale(17.0083 13.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint233_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1204.95 281.386) scale(17.0083 13.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint234_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1250.19 281.386) scale(17.0083 13.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint235_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1295.45 281.386) scale(17.0083 13.4276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint236_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(661.422 114.1) scale(220.518 174.093)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint237_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(963.585 58.4551) scale(5.87616 4.63906)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint238_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(358.225 169.537) scale(5.87614 4.63907)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint239_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1027.37 155.455) scale(349.291 275.756)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint240_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1020.13 65.1685) scale(226.187 178.569)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint241_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(826.929 99.9265) scale(31.3296 24.7339)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint242_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(867.619 87.8511) scale(5.87617 4.63907)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint243_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1026.89 118.506) scale(39.4204 31.1213)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint244_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(975.101 106.221) scale(5.87616 4.63907)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint245_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1097.73 152.705) scale(153.193 120.942)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint246_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1126.76 34.2569) scale(86.6952 68.4437)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint247_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1247.12 50.1555) scale(5.87614 4.63907)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint248_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1357.26 76.1021) scale(65.4939 51.7057)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint249_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1350.82 142.214) scale(108.162 85.3914)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint250_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(605.938 71.7657) scale(198.873 157.005)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint251_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(553.939 110.23) scale(61.3895 48.4653)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint252_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(810.717 16.0269) scale(90.2091 71.2178)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint253_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(710.351 77.524) scale(24.0361 18.9758)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint254_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1130.92 -12.3427) scale(181.334 143.158)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint255_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1004.22 86.8719) scale(49.5781 39.1406)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint256_radial_114_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1165.85 59.1322) scale(40.3357 31.844)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_114_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 832,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFondoLogin);
export default __webpack_public_path__ + "static/media/fondo_login.1a3690273502f7c20942f798a8c40e5d.svg";
export { ForwardRef as ReactComponent };